import { render, staticRenderFns } from "./safetyGearStockStatus.vue?vue&type=template&id=89d797a4"
import script from "./safetyGearStockStatus.vue?vue&type=script&lang=js"
export * from "./safetyGearStockStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89d797a4')) {
      api.createRecord('89d797a4', component.options)
    } else {
      api.reload('89d797a4', component.options)
    }
    module.hot.accept("./safetyGearStockStatus.vue?vue&type=template&id=89d797a4", function () {
      api.rerender('89d797a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearStockStatus.vue"
export default component.exports